/** @jsxImportSource @emotion/react */

import { COLORS } from '@btime/constants'
import { css } from '@emotion/react'
import React from 'react'

import { SmallText, Title } from '../presentation/Text'
import Button from '../actions/Button'
import FlexGrid, { FlexColumn } from '../structure/FlexGrid'
import Icon from '../shapes/Icon'
import Link from '../actions/Link'
import Panel from '../structure/Panel'
import Separator from '../helpers/Separator'

export const NotificationsWrapper = ({ children }) => {
  const style = css`
    height: auto !important;
    position: fixed;
    display: flex;
    flex-direction: column-reverse;
    justify-content: flex-end;
    align-items: flex-end;
    top: 1rem;
    right: 1rem;
    z-index: 1009;
  `
  return <div css={style}>{children}</div>
}

// TODO: Move to react-messagers package after components has its own package
export const Notification = ({ title, message, icon, iconColor, color, onClose, iconElem, button }) => {
  return (
    <div>
      <Panel smallPadding smallMargin width="18rem" maxWidth="100%" bgColor={COLORS.lightTransparent1}>
        <FlexGrid align="center" justify="space-between" gutter={0.5}>
          {iconElem || <Icon color={iconColor || color} name={icon} />}
          <FlexColumn flex={1}>
            <Title size="h6" color={color} noMargin>
              {title}
            </Title>
            <SmallText>{message}</SmallText>
            {!!button && (
              <div>
                <Separator weight={2} />
                <Button {...button} small>
                  {button.label}
                </Button>
              </div>
            )}
          </FlexColumn>

          <Link onClick={onClose} block>
            <Icon name="BsX" color={COLORS.dark3} />
          </Link>
        </FlexGrid>
      </Panel>
    </div>
  )
}
